import React from 'react';

import { styled } from '@tmap/mmm-style-guide/src/styled';

import imageUrlBuilder from '@sanity/image-url';
import client from '../../client';
import Caption from './caption';

const builder = imageUrlBuilder(client);

const ImageWrapper = styled('div')(() => ({
  // this serves to take up all available space on the slide
  // so the caption can decide whether it affects height
  height: 0,
  flexGrow: 1,
}));

const imageStyle = () => ({
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'scale-down',
});
const StyledPicture = styled('picture')(imageStyle);
const StyledImg = styled('img')(imageStyle);

const ThumbImg = styled('img')(() => ({
  display: 'block',
  objectFit: 'cover',
}));

export function ImageFull(props) {
  const { image } = props;
  return (
    <>
      <ImageWrapper className='swiper-zoom-container'>
        <StyledPicture>
          <source
            srcSet={
              builder.image(image)
                .format('webp')
                .width(1500)
                .fit('min')
                .url()
            }
          />
          <StyledImg
            src={
              builder.image(image)
                .width(1500)
                .fit('min')
                .url()
            }
            alt={(image || {}).alt}
          />
        </StyledPicture>
      </ImageWrapper>
      {image.alt && <Caption overlay>{image.alt}</Caption>}
    </>
  );
}

export function ImageThumb(props) {
  const { image } = props;

  return (
    <picture>
      <source
        srcSet={
          builder.image(image)
            .width(200)
            .height(128)
            .url()
        }
        width={200}
        height={128}
        media='(min-width: 960px)'
      />
      <source
        srcSet={
          builder.image(image)
            .width(150)
            .height(96)
            .url()
        }
        width={150}
        height={96}
        media='(min-width: 600px)'
      />
      <source
        srcSet={
          builder.image(image)
            .width(90)
            .height(57)
            .url()
        }
        width={90}
        height={57}
        media=''
      />
      <ThumbImg
        src={
          builder.image(image)
            .width(40)
            .height(30)
            .url()
        }
        alt={(image || {}).alt}
      />
    </picture>
  );
}
